// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".source-option[data-v-d5934b2e] {\n  gap: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1 1 auto;\n  margin-bottom: 0.5rem;\n}\n.source-option select[data-v-d5934b2e] {\n  max-width: 350px;\n}", ""]);
// Exports
module.exports = exports;
